import dayjs from 'dayjs';

export const createReclaimDateValue = () => dayjs();

export const parseReclaimDateValue = (value) => (value ? dayjs(value, 'YYYYMMDD') : undefined);

export const formatReclaimDateValue = (value) => dayjs(value).format('YYYYMMDD');
